import PAButton, { BUTTON_TYPE } from "component/design-system/buttons/PAButton";
import PAText, { FONT_SIZE } from "component/design-system/typography/PAText/PAText";
import { useTranslation } from "next-i18next";
import Link from "next/link";
import { useRouter } from "next/router";
import headerStyles from "./headerAccountTop.module.scss";
import styles from "./style.module.scss";

function HelpCenter(props: any) {
  const { t } = useTranslation("common");
  const { liveChat } = props;
  const router = useRouter();
  return (
    <div className={headerStyles.header_account_top_container}>

      <div className="icon-container d-flex flex-column">
        <PAText component="span" color="grey" fontSize={FONT_SIZE[0]}>
          {t("HelpCenter.heading")}
        </PAText>

        <div className="d-flex p-t-10 justify-content-between" style={{ gap: "calc(1 * var(--safari-root-font, 10px))" }}>
          <PAButton
            className={`btn p-10 ${styles.width_auto}`}
            bold
            onClick={liveChat}
          >
            <i
              className="fa fa-comments"
              style={{
                paddingRight: "calc(0.3 * var(--safari-root-font, 10px))",
                fontWeight: 600,
              }}
            />
            {t("HelpCenter.LIVE_CHAT")}
          </PAButton>

          <PAButton
            buttonType={BUTTON_TYPE.OUTLINE}
            className={`d-flex align-items-center btn p-10 ${styles.width_auto}`}
            bold
            onClick={() => router.push("/contact-us-for-car-parts")}
          >
            {t("HelpCenter.Contact_Us")}
          </PAButton>
        </div>

        <div className="d-flex justify-content-between p-t-20 align-items-center flex-wrap">
          <Link
            href="/account/orders"
            className="icon-inner-container"
            title="Order Status Updates at Your Fingertips"
          >

            <div className={`label p-0 ${styles.word_no_wrap}`}>{t("HelpCenter.Track_Order")}</div>

          </Link>
          <div className={`${headerStyles.seperator} p-l-5 p-r-5`}>-</div>
          <Link
            href="/questions-about-autoparts"
            className="icon-inner-container"
            title="Browse our FAQ Section for Common Queries and Answers"
          >

            <div className={`label p-0 ${styles.word_no_wrap}`}>{t("HelpCenter.FAQ")}</div>

          </Link>
          <div className={`${headerStyles.seperator} p-l-5 p-r-5`}>-</div>
          <Link
            href="/articles/ultimate-buying-guides"
            className="icon-inner-container"
            title="Access Informative Automotive Articles for Valuable Guidance"
          >

            <div className={`label p-0 ${styles.word_no_wrap}`}>{t("HelpCenter.User_Guide")}</div>

          </Link>
        </div>
      </div>
    </div>
  );
}

export default HelpCenter;
